import { useSearchParams } from "react-router-dom";
import { SimpleCard } from "../../../components/cards/simpleCard";

export const SignUpType = () => {
  const [, setSearchParams] = useSearchParams();

  return (
    <div className="flex flex-col gap-4 md:gap-5">
      <div className="text-[20px] font-bold mb-2 md:mb-0">Register As</div>

      <SimpleCard
        text="A Cooperative"
        subtext={`Create a cooperative account to manage all your members and activities in one place.`}
        growAnimate
        className=""
        onClick={() => {
          setSearchParams({ type: "cooperative" });
        }}
      />

      <SimpleCard
        text="A Member"
        subtext="Create a member account to join your cooperative, track contibutions, and much more."
        growAnimate
        onClick={() => {
          setSearchParams({ type: "member" });
        }}
      />
    </div>
  );
};
